import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {UiStateService} from "../../core/services/ui-state.service";
import {FacebookFundraiserService} from '../../core/services/facebook-fundraiser.service';

@Component({
    selector: 'facebook-dialog',
    templateUrl: './facebook-dialog.component.html',
    styles: [`
        .form-group {
            z-index: 0;
        }
    `]
})
export class FacebookDialogComponent implements OnInit {

    @Input() participantId: number;

    constructor(
        private facebookFundraiserService: FacebookFundraiserService,
        public activeModal: NgbActiveModal,
        public uiStateService: UiStateService
    ) {}

    ngOnInit() {

    }

    public dismissModal(reason: any) {
        this.facebookFundraiserService.acknowledgeModal(this.participantId);
        this.activeModal.dismiss(reason);
    }
}
